import { FEATURE_FLAGS_BASE_URL } from '@/constants/solarEcomm/ecommBaseUrls';
import getEnv from '@/utils/environment';
import axiosRequest from '../axiosClient';

type FeatureFlagResponse = Record<string, string | string[]>;

export const getFeatureFlags = async (): Promise<FeatureFlagResponse> => {
  const env = getEnv();
  const flagData = await axiosRequest<FeatureFlagResponse>({
    url: FEATURE_FLAGS_BASE_URL[env],
    method: 'GET',
  });

  return flagData.data;
};
